import { Container, Grid, Typography, Box } from '@mui/material';
import React from 'react';
import Technology from './Technology/Technology';
import './OfferingClient.css';
import technologies from '../../../data/technology_data.json';

const OfferingClient = () => {
  return (
    <Container sx={{ py: 10 }}>
      <Box>
        <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 2 }}>
          SkillSet
        </Typography>
      </Box>
      <Container
        sx={{
          mt: 3,
          p: 3,
          borderRadius: 3,
        }}
      >
        <Grid container className="skillCategoryContainer">
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className="skillCategory"
            sx={{ pt: 3 }}
          >
            <Typography
              variant="h5"
              sx={{ color: 'dimGray', fontWeight: 'bold' }}
            >
              Frontend
            </Typography>
            {technologies[0]?.frontend.map((tech) => (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                key={tech.name}
                className="technologyParent"
              >
                <Technology tech={tech}></Technology>
              </Grid>
            ))}
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className="skillCategory"
            sx={{ pt: 3 }}
          >
            <Typography
              variant="h5"
              sx={{ color: 'dimGray', fontWeight: 'bold' }}
            >
              Backend
            </Typography>
            {technologies[0]?.backend.map((tech) => (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                key={tech.name}
                className="technologyParent"
              >
                <Technology tech={tech}></Technology>
              </Grid>
            ))}
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className="skillCategory"
            sx={{ pt: 3 }}
          >
            <Typography
              variant="h5"
              sx={{ color: 'dimGray', fontWeight: 'bold' }}
            >
              Tools &#38; Kit
            </Typography>
            {technologies[0]?.tools.map((tech) => (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                key={tech.name}
                className="technologyParent"
              >
                <Technology tech={tech}></Technology>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Container>
    </Container>
  );
};

export default OfferingClient;
